import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Checkbox, TextField, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState, useMemo } from 'react'
import { TimePicker } from '@material-ui/pickers'
import moment from 'moment'

import { MainButton } from '../Button/MainButton'

const useStyles = makeStyles((theme) => ({
    dialogActions: {
        justifyContent: 'flex-start',
        padding: '16px 0px 6px 0px'
    },
    textField: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& .MuiTextField-root': {
            minWidth: '100%',
            marginBottom: '16px'
        },
        '& .MuiFilledInput-underline': {
            minWidth: '100%'
        }
    },
    column: {
        width: '40%'
    }
}))

const CloseArea = (props) => {
    const classes = useStyles()
    const [startTimeOpen, setStartTimeOpen] = useState(false)
    const [endTimeOpen, setEndTimeOpen] = useState(false)
    const [startTime, setStartTime] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [timeError, setTimeError] = useState(false)
    const [allDay, setAllDay] = useState(false)
    const [selectedArea, selectArea] = useState({})

    let {
        isShown,
        setIsShown,
        onConfirmDelete,
        date,
        area,
        isDeleteLoading,
        event,
        areas,
        confirmButtonText
    } = props

    const isDisabled = !!area?.disabled

    useEffect(() => {
        if (event) {
            setStartTime(moment(event.start).format('HH:mm'))
            setEndTime(moment(event.end).format('HH:mm'))
            if (event.disabled_for_day) setAllDay(true)
        } else {
            setStartTime(null)
            setEndTime(null)
        }
    }, [event])

    useEffect(() => {
        if (area) selectArea(area)
    }, [area])

    const isClosedAllDay = useMemo(() => {
        return !!area?.events?.find(e => e.disabled_for_day === true)
    }, [area])

    const save = () => {
        const ev = {
            start_time: startTime,
            end_time: endTime,
            date,
            area_id: selectedArea._id,
            disabled_for_day: allDay
        }

        if (event?.buffer) {
            ev.start_time = moment(startTime, 'HH:mm').subtract(event.buffer, 'minutes').format('HH:mm')
            ev.end_time = moment(endTime, 'HH:mm').add(event.buffer, 'minutes').format('HH:mm')
        }

        if (event?.event_id) ev._id = event.event_id

        onConfirmDelete(ev)
        setAllDay(false)
    }

    const deleteEvent = () => {
        const ev = {
            _id: event.event_id,
            delete: true
        }

        onConfirmDelete(ev)
        setAllDay(false)
    }

    const title = useMemo(() => {
        if (!event) return isDisabled ? `Open ${area?.name}?` : `Close ${area?.name}?`

        return event.title
    }, [isShown, event, isDisabled])

    const overlaps = (ev) => {
        if (moment(startTime, 'HH:mm').isBetween(moment(ev.start_time, 'HH:mm'), moment(ev.end_time, 'HH:mm')) || moment(endTime, 'HH:mm').isBetween(moment(ev.start_time, 'HH:mm'), moment(ev.end_time, 'HH:mm'))) {
            return true
        }

        return false
    }

    const hasOverlap = useMemo(() => {
        if (event && area) {

            const ourArea = areas.find(a => a._id == selectedArea._id)
            if (ourArea) {
                let hasOverlappingEvent = ourArea.events.find(e => {
                    return (e._id != event.event_id && !!overlaps(e))
                })

                if (hasOverlappingEvent) {
                    return true
                }

                return false
            }

            return false
        }

        return false

    }, [selectedArea, areas, startTime, endTime])


    const canSave = useMemo(() => {
        if (hasOverlap) return false
        if (allDay || isDisabled) return true
        if (!startTime || !endTime) return false
        if (moment(startTime, 'HH:mm').isAfter(moment(endTime, 'HH:mm'))) return false
        return true
    }, [allDay, startTime, endTime, isDisabled, hasOverlap])

    const getText = () => {

        if (isDisabled) {
            return (
                <Typography
                    variant="body2"
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        fontWeight: '400',
                        marginBottom: 16
                        // marginTop: 16
                    }}>
                    Are you sure you want to open this area?
                </Typography>
            )
        }

        if (event?.manual) {
            return (
                <Typography
                    variant="body2"
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        fontWeight: '400',
                        marginBottom: 16
                        // marginTop: 16
                    }}>
                    Area closed - adjust the times here or remove the closure below.
                </Typography>
            )
        }

        if (event) {
            return (
                <Typography
                    variant="body2"
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        fontWeight: '400',
                        marginBottom: 16
                        // marginTop: 16
                    }}>
                    Normal play time - adjust the times and/or area here.
                </Typography>
            )
        }

        return (
            <Typography
                variant="body2"
                style={{
                    fontFamily: 'Nunito',
                    color: '#1A1A35',
                    fontSize: '16px',
                    lineHeight: '22px',
                    fontWeight: '400',
                    marginBottom: 16
                    // marginTop: 16
                }}>
                Are you sure you want to close <strong>{area?.name}</strong> on <strong>{moment(date).format('MMM DD, YYYY')}</strong>? This will prevent new playgroups from being shepherded to this area. Currently scheduled groups will be relocated, which may cause adjustments to the overall play yard schedule.
            </Typography>
        )
    }

    return (
        <Dialog
            open={isShown}
            className={classes.dialog}
            onClose={() => {
                if (!isDeleteLoading) {
                    setIsShown(false)
                }
                setAllDay(false)
            }}
            PaperProps={{
                style: {
                    minWidth: '500px',
                    maxWidth: '500px',
                    width: '500px',
                    height: 500
                }
            }}>
            <DialogTitle>
                <Typography
                    style={{
                        fontFamily: 'Nunito',
                        color: '#1A1A35',
                        fontSize: '16px',
                        lineHeight: '22px',
                        textTransform: 'uppercase',
                        fontWeight: '800',
                        marginBottom: 16
                    }}>
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent style={{ paddingTop: 0 }}>
                {getText()}

                {
                    event && (
                        <div style={{ marginBottom: 16 }}>
                            <Typography
                                variant="overline"
                                style={{
                                    marginBottom: 8
                                }}>
                                Area
                            </Typography>
                            <TextField
                                select
                                label="Select Area"
                                error={hasOverlap}
                                style={{ marginBottom: 8 }}
                                onChange={e => {
                                    const val = e.target.value
                                    const newArea = areas.find(a => a._id == val)
                                    if (newArea) selectArea(newArea)
                                }}
                                variant='filled'
                                value={selectedArea._id}
                            >
                                {
                                    areas.map(a => {
                                        return <MenuItem key={a._id} value={a._id}>{a.name}</MenuItem>
                                    })
                                }
                            </TextField>
                            <br />
                            {hasOverlap && <Typography variant='body' style={{ color: '#EB4C4C', marginTop: 8 }}>This area has a conflicting event at this time</Typography>}
                        </div>
                    )
                }

                {
                    !isDisabled && (

                        <div className={classes.textField}>
                            <div className={classes.column}>
                                <Typography
                                    variant="overline"
                                    style={{
                                        marginBottom: 8
                                    }}>
                                    {event?.manual ? 'Closure Start Time' : 'Start Time'}
                                </Typography>
                                <TimePicker

                                    open={startTimeOpen}
                                    label="Start Time"
                                    onOpen={() => setStartTimeOpen(true)}
                                    disabled={allDay || isDisabled}
                                    onClose={() => setStartTimeOpen(false)}
                                    error={timeError}
                                    helperText={timeError ? 'Start cannot be before facility visit start time' : ''}
                                    variant="inline"
                                    format="hh:mm a"
                                    margin="normal"
                                    id="start-date"
                                    inputVariant="filled"
                                    value={startTime ? moment(startTime, 'HH:mm') : null}
                                    onChange={(e) => {
                                        setStartTime(e.format('HH:mm'))
                                    }}
                                    className={classes.datePicker2}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Date',
                                        className: classes.calendarButton
                                    }}
                                />
                            </div>
                            <div style={{ paddingTop: 30 }}>
                                <Typography
                                    variant="overline"
                                    style={{
                                        marginBottom: 8
                                    }}>
                                    To
                                </Typography>
                            </div>

                            <div className={classes.column}>
                                <Typography
                                    variant="overline"
                                    style={{
                                        marginBottom: 8
                                    }}>
                                    {event?.manual ? 'Closure End Time' : 'End Time'}
                                </Typography>
                                <TimePicker

                                    open={endTimeOpen}
                                    label="End Time"
                                    onOpen={() => setEndTimeOpen(true)}
                                    onClose={() => setEndTimeOpen(false)}
                                    disabled={allDay || isDisabled}
                                    error={timeError}
                                    helperText={timeError ? 'Start cannot be before facility visit start time' : ''}
                                    variant="inline"
                                    format="hh:mm a"
                                    margin="normal"
                                    id="start-date"
                                    inputVariant="filled"
                                    value={endTime ? moment(endTime, 'HH:mm') : null}
                                    onChange={(e) => {
                                        setEndTime(e.format('HH:mm'))
                                    }}
                                    className={classes.datePicker2}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Date',
                                        className: classes.calendarButton
                                    }}
                                />
                            </div>
                        </div>
                    )
                }

                {
                    !event && !isDisabled && (

                        <div>

                            <Checkbox
                                checked={allDay}
                                onChange={() => {
                                    if (!allDay) {
                                        setStartTime(null)

                                        setEndTime(null)
                                    }
                                    setAllDay(!allDay)
                                }}
                            />
                            <Typography
                                variant="overline"
                                style={{
                                }}>
                                All Day
                            </Typography>
                        </div>
                    )
                }


            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <MainButton
                    variant="contained"
                    label="Confirm"
                    backgroundColor="#EB4C4C"
                    onClick={save}
                    disabled={!canSave}
                    style={{ height: 40 }}
                />
                <MainButton
                    variant="outlined"
                    label="too scared"
                    onClick={() => setIsShown(false)}
                    disabled={isDeleteLoading}
                    style={{ height: 40 }}
                />
                {
                    event?.manual && (
                        <MainButton
                            variant="contained"
                            label="Delete"
                            backgroundColor="#EB4C4C"
                            onClick={deleteEvent}
                            disabled={false}
                            style={{ height: 40 }}
                        />
                    )
                }
            </DialogActions>
        </Dialog>
    )
}

export default CloseArea